import {getApi} from '../../modules/common/utils/api'

const api = getApi('audit')

export function getAuditReport(params) {
  return api.post(`/api/v1/reports`, {audit: params})
}

export function sendAuditReport(params) {
  return api.post(`/api/v1/reports`, {audit: params})
}
